export const desktopSideNavWidth = 310
